<template>
  <b-container class="premium-content">
    <section class="section" v-show="!isPaidUser && userPlan !== 'Trial'">
      <UpgradeSection />
    </section>
    <div v-show="isPaidUser || userPlan === 'Trial'">
      <h2>{{ stepNumber }}</h2>
    </div>
    <div v-show="isPaidUser || userPlan === 'Trial'">
      <b-table borderless responsive class="history-table" show-empty>
        <template #empty>
          <h4>{{ stepTitle }}</h4>
        </template>
      </b-table>

      <!-- Video Lesson -->
      <div class="video-player" v-show="stepUrl != ''">
        <b-embed
          class="video-frame"
          type="iframe"
          aspect="16by9"
          :src="stepUrl"
          allowfullscreen
          title="Dropsmart video content"
        ></b-embed>
      </div>

      <!-- Text Lesson -->
      <TextContent />

      <!-- Form Content -->
      <ContactForm />
    </div>
  </b-container>
</template>

<script>
import { h } from "vue";

import TextContent from "@/components/private/my-premium-material/TextContent.vue";
import ContactForm from "@/components/private/my-premium-material/ContactForm.vue";
import UpgradeSection from "@/components/private/my-premium-material/UpgradeSection.vue";

export default {
  props: {
    stepsInfoList: {
      type: Array,
    },
    customerInfo: {
      type: Object,
    },
  },
  mounted() {
    this.$root.$on("step-number", (step, title, url) => {
      this.stepNumber = step;
      this.stepTitle = title;
      this.stepUrl = url;
    });
  },
  created() {
    let index = parseInt(this.$route.query.step) - 1;
    this.stepNumber = "Step " + this.stepsInfoList[index].stepNumber;
    this.stepTitle = this.stepsInfoList[index].stepTitle;
    this.stepUrl = this.stepsInfoList[index].stepUrl;
  },
  data() {
    return {
      index: parseInt(this.$route.query.step) - 1,
      stepNumber: "",
      stepTitle: "",
      stepUrl: "",
      isPaidUser: JSON.parse(sessionStorage.getItem("customerInfo")).user.paid,
      userPlan: JSON.parse(sessionStorage.getItem("customerInfo")).user.plan,
    };
  },
  render() {
    return h("div", this.message);
  },
  components: {
    TextContent,
    ContactForm,
    UpgradeSection,
  },
};
</script>

<style lang="scss">
$color: #000000;

.box {
  color: $color;
  a {
    color: #509610;
    &:hover {
      color: $color;
    }
  }
}

.premium-content {
  max-width: 935px;
  margin: initial;
  padding: 50px 0;
  padding-left: 7%;
  height: 100%;
  h2 {
    font-size: 30px;
    font-weight: 700;
  }
}

.history-table {
  font-size: 18px;
  background: #ffffff;
  color: #000000;
  thead {
    display: none;
    border-top: 1px solid #b3b3b3;
    border-bottom: 1px solid #b3b3b3;
    font-size: 18px;
    padding: 0 25px;
    th {
      line-height: 30px;
      padding: 1.6875rem 1.5625rem;
      width: 20%;
      &:nth-child(4),
      &:nth-child(5) {
        text-align: right;
      }
    }
  }
  tbody {
    border-top: 1px solid #b3b3b3;
    .row-history {
      .status {
        border-radius: 3px;
        color: #ffffff;
        display: inline-block;
        line-height: 25px;
        padding: 0 7px;
        vertical-align: middle;
      }
    }
    tr {
      border-bottom: 1px solid #b3b3b3;
    }
    td {
      line-height: 30px;
      padding: 1.6875rem 1.5625rem;
      width: 20%;
      &:nth-child(4),
      &:nth-child(5) {
        text-align: right;
      }
    }
    p {
      margin: 0;
      &.invoiceNumber {
        display: flex;
        svg {
          fill: #535353;
          margin-right: 15px;
          width: 15px;
        }
      }
      &.total {
        font-size: 16px;
      }
      &.status {
        font-size: 14px;
      }
      &.dueDate {
        font-size: 16px;
      }
    }
    .download {
      color: #ee4586;
      font-size: 16px;
    }
  }
  .row-history {
    &.paid .status {
      background-color: #49c200;
    }
    &.failed .status {
      background-color: #e90000;
    }
    &.open .status {
      background-color: #ffa200;
    }
    &.refunded .status {
      background-color: #9d009f;
    }
    &.processing .status {
      background-color: #ffd900;
    }
  }
}

.video-player {
  margin: 35px auto;
}

@media screen and (max-width: 775px) {
  .premium-content {
    margin-left: 0;
  }
}
</style>

<style scoped lang="scss">
.premium-content {
  h2 {
    margin-bottom: 35px;
  }
}
</style>
